import './TimeLine.css';

export const TimeLine = () => {
    return (
        <div className="time-line">
            <div className="time-line__item-count">
                <span className="time-line__text">0 из 100</span>
                <span className="time-line__item-text">вещей</span>
            </div>
            <span className="time-line__item-or">или</span>
            <div className="time-line__item-count time-line__time-out">
                <span className="time-line__text">01:00</span>
                <span className="time-line__item-text">вещей</span>
            </div>
        </div>
    );
};
